const getConfluenceUrl = () => {
  if (
    window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)
  ) {
    return process.env.REACT_APP_DEV_CONFLUENCE_URL;
  }

  return process.env.REACT_APP_PROD_CONFLUENCE_URL;
};
export default getConfluenceUrl;
